import React from "react";
import { ContentSection, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { CloudFileAudioTechnical } from "../../../CloudFileDetails";

interface AudioCloudFileTechnicalSectionProps {
    audioTechnical: CloudFileAudioTechnical;
    isLoading: boolean;
}

export const AudioCloudFileTechnicalSection = ({
    audioTechnical,
    isLoading
}: AudioCloudFileTechnicalSectionProps): JSX.Element => {
    return (
        <ContentSection header="Technical" isLoading={isLoading} style={{ height: 300 }}>
            <GridRow>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Duration"
                        testId="cloud-file-technical-duration"
                        value={audioTechnical.duration}
                    />
                    <LabeledText
                        label="Channels"
                        testId="cloud-file-technical-channels"
                        value={audioTechnical.channelsCount}
                    />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Bitrate"
                        testId="cloud-file-technical-audioBitRate"
                        value={audioTechnical.audioBitRate}
                    />
                    <LabeledText
                        label="Sample rate"
                        testId="cloud-file-technical-sampleRate"
                        value={audioTechnical.sampleRate}
                    />
                </GridColumn>
                <GridColumn sm={3}>
                    <LabeledText
                        label="Audio format"
                        testId="cloud-file-technical-audioFormat"
                        value={audioTechnical.audioFormat}
                    />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
